// Professional Color Palette
export const colorPalette = {
  // Primary Colors
  primary: {
    50: "#f5f5f5",
    100: "#e5e5e5",
    200: "#cccccc",
    300: "#a3a3a3",
    400: "#737373",
    500: "#000000", // main primary (black)
    600: "#111111",
    700: "#181818",
    800: "#1f1f1f",
    900: "#262626",
  },

  // Secondary Colors
  secondary: {
    50: "#f8fafc",
    100: "#f1f5f9",
    200: "#e2e8f0",
    300: "#cbd5e1",
    400: "#94a3b8",
    500: "#64748b", // Main secondary color
    600: "#475569",
    700: "#334155",
    800: "#1e293b",
    900: "#0f172a",
  },

  // Success Colors
  success: {
    50: "#f0fdf4",
    100: "#dcfce7",
    200: "#bbf7d0",
    300: "#86efac",
    400: "#4ade80",
    500: "#22c55e", // Main success color
    600: "#16a34a",
    700: "#15803d",
    800: "#166534",
    900: "#14532d",
  },

  // Warning Colors
  warning: {
    50: "#fffbeb",
    100: "#fef3c7",
    200: "#fde68a",
    300: "#fcd34d",
    400: "#fbbf24",
    500: "#f59e0b", // Main warning color
    600: "#d97706",
    700: "#b45309",
    800: "#92400e",
    900: "#78350f",
  },

  // Error Colors
  error: {
    50: "#fef2f2",
    100: "#fee2e2",
    200: "#fecaca",
    300: "#fca5a5",
    400: "#f87171",
    500: "#ef4444", // Main error color
    600: "#dc2626",
    700: "#b91c1c",
    800: "#991b1b",
    900: "#7f1d1d",
  },

  // Neutral Colors
  neutral: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#e5e5e5",
    300: "#d4d4d4",
    400: "#a3a3a3",
    500: "#737373",
    600: "#525252",
    700: "#404040",
    800: "#262626",
    900: "#171717",
  },

  // Brand Colors - ABSS
  brand: {
    orange: "#DF5D01", // primary brand accent - use for eyebrows, highlights, active states, metric numbers
    orangeLight: "#FB923C", // Books module color
    orangePale: "#FFF7ED", // orange tint backgrounds
    green: "#4ADE80", // CRM module color
    purple: "#C084FC", // Teams module color
    blue: "#1785B6",
    teal: "#0d9488",
  },
};
